import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Contractul ecranului Settings -> Service Catalog (v4/api,
 * `App\Settings\Catalog\CatalogSettings`): cele doua comutatoare ale
 * magazinului - se arata costul serviciului? se arata SLA-ul de raspuns?
 *
 * Forma raspunsului e inghetata in `settings/catalog/__fixtures__/
 * catalogPage.json`, citita si de proba din browser, si de cea din PHP.
 */
export interface CatalogVisibility {
  show_cost: number
  show_sla: number
}

export interface CatalogSettingsPage {
  visibility: CatalogVisibility
  /** Tabela setarilor exista? Fara ea, salvarea n-are unde sa scrie si ecranul o spune. */
  visibilityStorage: boolean
  canWrite: boolean
}

export interface WriteResult {
  status: 'OK' | 'ERROR'
  message: string
}

export function catalogSettingsQuery() {
  return queryOptions({
    queryKey: ['settings', 'catalog'],
    queryFn: () => apiGet<CatalogSettingsPage>('/settings/catalog'),
  })
}

/**
 * `Catalog::saveVisibility`. Se trimit numai casutele BIFATE, ca din
 * formularul vechi: pe server lipsa inseamna "nu".
 */
export function saveCatalogVisibility(visibility: { show_cost: boolean; show_sla: boolean }) {
  const fields: Record<string, string> = {}
  if (visibility.show_cost) fields.show_cost = '1'
  if (visibility.show_sla) fields.show_sla = '1'
  return apiPost<WriteResult>('/settings/catalog/visibility', fields)
}

/* -------------------------------------------------------------------------
 * Widgetul de intranet (cerinta CEC 33) - `App\Easeedesk\ServiceShop\Embed`.
 * ---------------------------------------------------------------------- */

export interface CatalogWidget {
  /** Tabela widgetului exista? (migrarea `Version20261001100000_ServiceCatalogEmbed`) */
  available: boolean
  company_id: number
  company_name: string
  enabled: boolean
  /** Cheia publica din snippet; '' pana la prima salvare. */
  public_key: string
  /** Originile din care are voie sa lucreze widgetul. */
  allowed_origins: string[]
  canWrite: boolean
}

export type CatalogWidgetWrite = WriteResult & Partial<CatalogWidget>

export function catalogWidgetQuery() {
  return queryOptions({
    queryKey: ['settings', 'catalog', 'widget'],
    queryFn: () => apiGet<CatalogWidget>('/settings/catalog/widget'),
  })
}

export function saveCatalogWidget(fields: { enabled: boolean; allowed_origins: string }) {
  return apiPost<CatalogWidgetWrite>('/settings/catalog/widget', {
    enabled: fields.enabled ? '1' : '0',
    allowed_origins: fields.allowed_origins,
  })
}

export function rotateCatalogWidgetKey() {
  return apiPost<CatalogWidgetWrite>('/settings/catalog/widget/rotate-key', {})
}

/** Adresa scriptului widgetului, pe portalul de unde se citeste pagina. */
export function widgetScriptUrl(portalOrigin: string): string {
  return `${portalOrigin.replace(/\/+$/, '')}/app/embed/service-shop.js`
}

/**
 * Cele doua randuri de pus in pagina intranetului. `div`-ul e locul in care se
 * deseneaza magazinul; scriptul il gaseste dupa `data-od-service-shop`.
 */
export function widgetSnippet(portalOrigin: string, publicKey: string): string {
  return (
    `<div data-od-service-shop="${publicKey}"></div>\n` +
    `<script src="${widgetScriptUrl(portalOrigin)}" async></script>`
  )
}
